import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  
  declare readonly tabTargets: HTMLElement[]
  declare readonly panelTargets: HTMLElement[]

  connect() {
    if (this.tabTargets.length > 0 && this.panelTargets.length > 0) {
      const activeIndex = this.tabTargets.findIndex((tab) =>
        tab.classList.contains("tab-active") ||
        tab.classList.contains("iw-tab-active") ||
        tab.getAttribute("aria-selected") === "true"
      )
      this.showTab(activeIndex >= 0 ? activeIndex : 0)
    }
  }

  switch(event: Event) {
    event.preventDefault()
    const clickedTab = event.currentTarget as HTMLElement
    const tabIndex = this.tabTargets.indexOf(clickedTab)
    this.showTab(tabIndex)
  }

  showTab(index: number) {
    // Hide all panels
    this.panelTargets.forEach((panel) => {
      panel.classList.add("hidden")
    })

    // Show the selected panel
    if (this.panelTargets[index]) {
      this.panelTargets[index].classList.remove("hidden")
    }

    // Update tab styling — toggle both DaisyUI's `tab-active` and our
    // pill-tab `iw-tab-active` so the same controller works for both styles.
    this.tabTargets.forEach((tab) => {
      tab.classList.remove("tab-active")
      tab.classList.remove("iw-tab-active")
      tab.setAttribute("aria-selected", "false")
    })

    if (this.tabTargets[index]) {
      const isPillTab = this.tabTargets[index].classList.contains("iw-tab") ||
        this.tabTargets[index].parentElement?.classList.contains("iw-tabs")
      this.tabTargets[index].classList.add(isPillTab ? "iw-tab-active" : "tab-active")
      this.tabTargets[index].setAttribute("aria-selected", "true")
    }
  }
}
